import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../root-saga/root-state';
import { initialState } from './index';

const selectDomain = (state: RootState) => state.knowledgeBase || initialState;

export const selectKnowledgeBaseItems = createSelector([selectDomain], (state) => state.items);
export const selectKnowledgeBaseTotal = createSelector([selectDomain], (state) => state.total);
export const selectKnowledgeBaseIsLoading = createSelector([selectDomain], (state) => state.isLoading);
export const selectKnowledgeBaseError = createSelector([selectDomain], (state) => state.error);
export const selectKnowledgeBaseIsSyncingBlogs = createSelector([selectDomain], (state) => state.isSyncingBlogs);
export const selectKnowledgeBaseIsCustomSyncing = createSelector([selectDomain], (state) => state.isCustomSyncing);
